import api from '../../api'
const state = {
  crfcode: '', // csrf token
  collection: '', // 公钥
  baseURL: api.baseURL()
}

const getters = {
  crfcode: state => state.crfcode,
  collection: state => state.collection,
  baseURL: state => state.baseURL
}

const actions = {
  getLogin({ commit }, data) { // 登录函数
    api.getDistrict(data).then(json => {
      console.log(json)
    })
  },
  AgetCrf({ commit }, inner) { // 获取token
    commit('getCrf', inner)
  },
  AgetCollection({ commit }, inner) { // 获取公钥
    commit('getCollection', inner)
  }
}

const mutations = {
  getCrf(state, inner) {
    state.crfcode = ''
    state.crfcode = inner
    console.log(inner)
  },
  getCollection(state, inner) {
    state.collection = ''
    state.collection = inner
    console.log(inner)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
